module.exports = __webpack_public_path__ + "static/img/model-like6.870a1e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-like6.png
// module id = Zeet
// module chunks = 36